module.exports = __webpack_public_path__ + "static/media/luis.45521370.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/luis.png
// module id = 1157
// module chunks = 0